import { render, staticRenderFns } from "./First_mobile.vue?vue&type=template&id=1653f4f7&scoped=true&"
import script from "./First_mobile.vue?vue&type=script&lang=js&"
export * from "./First_mobile.vue?vue&type=script&lang=js&"
import style0 from "./First_mobile.vue?vue&type=style&index=0&id=1653f4f7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1653f4f7",
  null
  
)

export default component.exports